/**
 * IONLOOP Assistant — source builder.
 *
 * Converts ranked search results into a compact, deduplicated list of source
 * references with a lightweight source-type classification. Only real indexed
 * pages are used — no invented sources.
 */

/**
 * Classify the kind of source page for prioritization.
 */
function classifySourceType(url, category) {
    var path = url || '';
    if (/^\/account-tools\//.test(path) || /^\/trading-tools\//.test(path)) {
        return 'product';
    }
    if (/^\/policies\//.test(path) || /^\/help-center\//.test(path)) {
        return 'help';
    }
    if (/^\/guides/.test(path)) {
        return 'guide';
    }
    if (/^\/news-articles\//.test(path)) {
        return 'article';
    }
    if (path === '/' || path === '/index' || path === '/index.html' || path === '/about' || path === '/about.html') {
        return 'overview';
    }
    return 'page';
}

    var TYPE_PRIORITY = {
    product: 1,
    guide: 2,
    help: 3,
    article: 4,
    overview: 5,
    page: 6
};

/**
 * Build a deduplicated sources list (max `limit`).
 * Source order follows retrieval relevance; source type is only a tie-breaker.
 */
function buildSources(results, options) {
    options = options || {};
    var limit = options.limit || 3;
    var seen = {};
    var sources = [];

    (results || []).forEach(function (result) {
        var url = result.url;
        if (!url || seen[url]) {
            return;
        }
        var title = (result.title || result.heading || '').trim();
        if (!title) {
            return;
        }
        seen[url] = true;
        sources.push({
            title: title.charAt(0).toUpperCase() + title.slice(1),
            url: url,
            sectionId: result.sectionId,
            type: classifySourceType(url, result.category),
            score: result.score || 0
        });
    });

    // Relevance first (results arrive score-sorted); type breaks near-ties.
    sources.sort(function (a, b) {
        var diff = b.score - a.score;
        if (Math.abs(diff) > 0.01) {
            return diff;
        }
        return TYPE_PRIORITY[a.type] - TYPE_PRIORITY[b.type];
    });

    return sources.slice(0, limit);
}

module.exports = {
    classifySourceType: classifySourceType,
    buildSources: buildSources
};
